// // /* eslint-disable jsx-a11y/anchor-is-valid */
// // import { useEffect } from 'react'
// // import { Outlet, Link } from 'react-router-dom'
// // import { toAbsoluteUrl } from '../../../_metronic/helpers'

// // const AuthLayout = () => {
// //   useEffect(() => {
// //     const root = document.getElementById('root')
// //     if (root) {
// //       root.style.height = '100%'
// //     }
// //     return () => {
// //       if (root) {
// //         root.style.height = 'auto'
// //       }
// //     }
// //   }, [])

// //   return (
// //     <div className='d-flex flex-column flex-lg-row flex-column-fluid h-100'>
// //       {/* begin::Body */}
// //       <div
// //         className='d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1'
// //         style={{ background: '#003B73' }}
// //       >
// //         {/* begin::Form */}
// //         <div className='d-flex  '>
// //           <img
// //             alt='Logo'
// //             src={toAbsoluteUrl('/media/logos/PFC Logo - white.png')}
// //             style={{
// //               height: '50px !important',
// //               width: '100px',
// //               // width: '50px',
// //               marginLeft: '-25px',
// //               marginTop: '-2px',
// //             }}
// //           // className='h-100px'
// //           />
// //         </div>

// //         <div className='d-flex flex-center flex-column flex-lg-row-fluid'>
// //           {/* <div style={{ fontSize: '42px', marginBottom: '42px', color: 'white' }}>
// //             Gembira Dapat Berjumpa Awak
// //           </div>{' '} */}
// //           {/* begin::Wrapper */}
// //           <div className='w-lg-500px p-10'>
// //             <Outlet />
// //           </div>
// //           {/* end::Wrapper */}
// //         </div>
// //         {/* end::Form */}

// //         {/* begin::Footer */}
// //         <div className='d-flex flex-center flex-wrap px-5'>
// //           {/* begin::Links */}
// //           <div className='d-flex fw-semibold text-white fs-base'>
// //             <a href='#' className='px-5 text-white' target='_blank'>
// //               Copyright &copy; {new Date().getFullYear().toString()} ASM Global
// //             </a>
// //             <a href='#' className='px-5 text-white' target='_blank'>
// //               Terms
// //             </a>

// //             {/* <a href='#' className='px-5' target='_blank'>
// //               Plans
// //             </a> */}

// //             <a href='#' className='px-5 text-white' target='_blank'>
// //               Contact Us
// //             </a>

// //             <Link to='/auth/register' className='px-5 text-white'>
// //               Register
// //             </Link>


// //           </div>
// //           {/* end::Links */}
// //         </div>
// //         {/* end::Footer */}
// //       </div>
// //       {/* end::Body */}

// //       {/* begin::Aside */}
// //       <div className='d-flex flex-lg-row-fluid w-lg-50 bgi-size-cover order-1 order-lg-2 overflow-hidden position-relative'>
// //         <div
// //           // className='position-fixed'
// //           style={{ left: '50%' }}
// //         >
// //           <video autoPlay muted loop style={{ maxWidth: '100%', position: 'fixed' }}>
// //             <source src='/media/logos/intro_video.mp4' type='video/mp4' />
// //             Your browser does not support HTML5 video.
// //           </video>
// //         </div>
// //       </div>
// //       {/* end::Aside */}
// //     </div>
// //   )
// // }

// // export { AuthLayout }




























// // import { useEffect, useState, useRef } from 'react'
// // import { Outlet, Link, useNavigate } from 'react-router-dom'
// // import { toAbsoluteUrl } from '../../../_metronic/helpers'
// // import { Modal } from 'react-bootstrap'
// // import * as Yup from 'yup'
// // import { useFormik } from 'formik'
// // import clsx from 'clsx'
// // import { successToast, errorToast } from '../../../_metronic/helpers/components/Toaster'

// // // Removed strict validation for development
// // const PhoneVerificationSchema = Yup.object().shape({
// //   phoneNumber: Yup.string(),
// //   otp1: Yup.string(),
// //   otp2: Yup.string(),
// //   otp3: Yup.string(),
// //   otp4: Yup.string(),
// // })

// // export const AuthLayout = () => {
// //   const navigate = useNavigate()
// //   const [showModal, setShowModal] = useState(false)
// //   const [otpSent, setOtpSent] = useState(false)
// //   const [phoneNumber, setPhoneNumber] = useState('')
// //   const [isResending, setIsResending] = useState(false)

// //   // References for OTP input fields
// //   const inputRef1 = useRef<HTMLInputElement>(null)
// //   const inputRef2 = useRef<HTMLInputElement>(null)
// //   const inputRef3 = useRef<HTMLInputElement>(null)
// //   const inputRef4 = useRef<HTMLInputElement>(null)

// //   useEffect(() => {
// //     const root = document.getElementById('root')
// //     if (root) {
// //       root.style.height = '100%'
// //     }
// //     return () => {
// //       if (root) {
// //         root.style.height = 'auto'
// //       }
// //     }
// //   }, [])

// //   const handleRegisterClick = (e: React.MouseEvent) => {
// //     e.preventDefault()
// //     setShowModal(true)
// //   }

// //   const resetModal = () => {
// //     setShowModal(false)
// //     setOtpSent(false)
// //     setPhoneNumber('')
// //     formik.resetForm()
// //   }

// //   const sendOTP = async (phoneNumber: string) => {
// //     try {
// //       // For development, immediately proceed to OTP screen without validation
// //       console.log('Sending OTP to:', phoneNumber)
// //       // No delay for testing
// //       setPhoneNumber(phoneNumber || '8888888888') // Default number if empty
// //       setOtpSent(true)
// //       // Focus the first OTP input field
// //       setTimeout(() => {
// //         if (inputRef1.current) {
// //           inputRef1.current.focus()
// //         }
// //       }, 100)
// //     } catch (error) {
// //       console.error('OTP Send Error:', error)
// //     } finally {
// //       setIsResending(false)
// //     }
// //   }

// //   const resendOTP = async () => {
// //     setIsResending(true)
// //     await sendOTP(phoneNumber)
// //   }

// //   const verifyOTP = async () => {
// //     try {
// //       const otp = `${formik.values.otp1}${formik.values.otp2}${formik.values.otp3}${formik.values.otp4}`
// //       // For development, always succeed without validation
// //       console.log('Verifying OTP:', otp)
// //       // No delay for testing
// //       resetModal()
// //       navigate('/auth/register')
// //     } catch (error) {
// //       console.error('OTP Verification Error:', error)
// //     }
// //   }

// //   const handleOtpInput = (e: React.ChangeEvent<HTMLInputElement>, nextRef: React.RefObject<HTMLInputElement> | null) => {
// //     const value = e.target.value
// //     if (value.length === 1 && nextRef && nextRef.current) {
// //       nextRef.current.focus()
// //     }
// //   }

// //   const formik = useFormik({
// //     initialValues: {
// //       phoneNumber: '',
// //       otp1: '',
// //       otp2: '',
// //       otp3: '',
// //       otp4: '',
// //     },
// //     validationSchema: PhoneVerificationSchema,
// //     onSubmit: async (values) => {
// //       if (!otpSent) {
// //         await sendOTP(values.phoneNumber)
// //       } else {
// //         await verifyOTP()
// //       }
// //     },
// //   })

// //   return (
// //     <>
// //       <div className='d-flex flex-column flex-lg-row flex-column-fluid h-100'>
// //         {/* begin::Body */}
// //         <div
// //           className='d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1'
// //           style={{ background: '#003B73' }}
// //         >
// //           {/* begin::Form */}
// //           <div className='d-flex'>
// //             <img
// //               alt='Logo'
// //               src={toAbsoluteUrl('/media/logos/PFC Logo - white.png')}
// //               style={{
// //                 height: '50px !important',
// //                 width: '100px',
// //                 marginLeft: '-25px',
// //                 marginTop: '-2px',
// //               }}
// //             />
// //           </div>

// //           <div className='d-flex flex-center flex-column flex-lg-row-fluid'>
// //             <div className='w-lg-500px p-10'>
// //               <Outlet />
// //             </div>
// //           </div>

// //           {/* begin::Footer */}
// //           <div className='d-flex flex-center flex-wrap px-5'>
// //             <div className='d-flex fw-semibold text-white fs-base'>
// //               <a href='#' className='px-5 text-white' target='_blank'>
// //                 Copyright &copy; {new Date().getFullYear().toString()} Plastics For Change
// //               </a>
// //               <a href='#' className='px-5 text-white' target='_blank'>
// //                 Terms
// //               </a>
// //               <a href='#' className='px-5 text-white' target='_blank'>
// //                 Contact Us
// //               </a>
// //               <a href='#' className='px-5 text-white' onClick={handleRegisterClick}>
// //                 Register
// //               </a>
// //             </div>
// //           </div>
// //         </div>

// //         {/* begin::Aside */}
// //         <div className='d-flex flex-lg-row-fluid w-lg-50 bgi-size-cover order-1 order-lg-2 overflow-hidden position-relative'>
// //           <div style={{ left: '50%' }}>
// //             {/* <video autoPlay muted loop style={{ maxWidth: '100%', position: 'fixed' }}>
// //               <source src='/media/logos/intro_video.mp4' type='video/mp4' />
// //               Your browser does not support HTML5 video.
// //             </video> */}
// //             <video
// //               autoPlay
// //               muted
// //               loop
// //               style={{
// //                 width: '50%',
// //                 height: '100vh',
// //                 position: 'fixed',
// //                 objectFit: 'cover',
// //                 right: 0,
// //                 top: 0,
// //                 bottom: 0
// //               }}
// //             >
// //               <source src='/media/logos/intro_video.mp4' type='video/mp4' />
// //               Your browser does not support HTML5 video.
// //             </video>
// //           </div>
// //         </div>
// //       </div>

// //       {/* Phone Verification Modal */}
// //       <Modal show={showModal} onHide={resetModal} centered>
// //         <Modal.Header closeButton>
// //           <Modal.Title>Verification</Modal.Title>
// //         </Modal.Header>
// //         <Modal.Body className="p-6">
// //           <form onSubmit={formik.handleSubmit} noValidate className='form'>
// //             <div className="text-center mb-5">
// //               <h3 className="fw-bold mb-3">Welcome to Plastics for Change</h3>
// //               <p className="text-muted fs-6">Let us verify your details</p>
// //             </div>

// //             {!otpSent ? (
// //               <div className='mb-8'>
// //                 <label className='form-label fs-6 fw-bold mb-3'>Enter your mobile number</label>
// //                 <div className='d-flex'>
// //                   <input
// //                     placeholder='Enter your 10-digit mobile number'
// //                     {...formik.getFieldProps('phoneNumber')}
// //                     className={clsx(
// //                       'form-control form-control-lg me-3',
// //                       { 'is-invalid': formik.touched.phoneNumber && formik.errors.phoneNumber },
// //                       { 'is-valid': formik.touched.phoneNumber && !formik.errors.phoneNumber }
// //                     )}
// //                     type='text'
// //                     name='phoneNumber'
// //                     autoComplete='off'
// //                   />
// //                   <button
// //                     type='submit'
// //                     className='btn btn-primary'
// //                   >
// //                     Send OTP
// //                     {formik.isSubmitting && (
// //                       <span className='ms-2 spinner-border spinner-border-sm' role='status' aria-hidden='true'></span>
// //                     )}
// //                   </button>
// //                 </div>
// //                 {formik.touched.phoneNumber && formik.errors.phoneNumber && (
// //                   <div className='fv-plugins-message-container mt-2'>
// //                     <div className='fv-help-block'>
// //                       <span role='alert'>{formik.errors.phoneNumber}</span>
// //                     </div>
// //                   </div>
// //                 )}
// //               </div>
// //             ) : (
// //               <>
// //                 <div className='mb-8'>
// //                   <label className='form-label fs-6 fw-bold mb-3'>
// //                     Enter the OTP sent to +{phoneNumber.substring(0, 3)}*****{phoneNumber.substring(phoneNumber.length - 3)}
// //                   </label>
// //                   <div className='d-flex justify-content-center gap-3 mb-7'>
// //                     <input
// //                       ref={inputRef1}
// //                       maxLength={1}
// //                       className='form-control form-control-lg text-center fw-bold fs-2'
// //                       style={{ width: '60px', height: '60px' }}
// //                       {...formik.getFieldProps('otp1')}
// //                       onChange={(e) => {
// //                         formik.handleChange(e);
// //                         handleOtpInput(e, inputRef2);
// //                       }}
// //                     />
// //                     <input
// //                       ref={inputRef2}
// //                       maxLength={1}
// //                       className='form-control form-control-lg text-center fw-bold fs-2'
// //                       style={{ width: '60px', height: '60px' }}
// //                       {...formik.getFieldProps('otp2')}
// //                       onChange={(e) => {
// //                         formik.handleChange(e);
// //                         handleOtpInput(e, inputRef3);
// //                       }}
// //                     />
// //                     <input
// //                       ref={inputRef3}
// //                       maxLength={1}
// //                       className='form-control form-control-lg text-center fw-bold fs-2'
// //                       style={{ width: '60px', height: '60px' }}
// //                       {...formik.getFieldProps('otp3')}
// //                       onChange={(e) => {
// //                         formik.handleChange(e);
// //                         handleOtpInput(e, inputRef4);
// //                       }}
// //                     />
// //                     <input
// //                       ref={inputRef4}
// //                       maxLength={1}
// //                       className='form-control form-control-lg text-center fw-bold fs-2'
// //                       style={{ width: '60px', height: '60px' }}
// //                       {...formik.getFieldProps('otp4')}
// //                       onChange={(e) => {
// //                         formik.handleChange(e);
// //                       }}
// //                     />
// //                   </div>

// //                   <div className='text-center mb-10'>
// //                     <span className='text-muted me-2'>Didn't receive OTP Code?</span>
// //                     <a
// //                       href='#'
// //                       className='link-primary fw-bold'
// //                       onClick={(e) => {
// //                         e.preventDefault();
// //                         if (!isResending) {
// //                           resendOTP();
// //                         }
// //                       }}
// //                     >
// //                       {isResending ? 'Sending...' : 'Resend Code'}
// //                     </a>
// //                   </div>
// //                 </div>

// //                 <div className='d-flex justify-content-between'>
// //                   <a href='#' className='btn btn-link' onClick={resetModal}>
// //                     Cancel
// //                   </a>
// //                   <button
// //                     type='submit'
// //                     className='btn btn-primary'
// //                   >
// //                     Confirm
// //                     {formik.isSubmitting && (
// //                       <span className='ms-2 spinner-border spinner-border-sm' role='status' aria-hidden='true'></span>
// //                     )}
// //                   </button>
// //                 </div>

// //                 <div className='d-flex justify-content-between mt-5 pt-3 border-top'>
// //                   <a href='#' className='link-primary'>Privacy Policy</a>
// //                   <a href='#' className='link-primary'>Terms & Conditions</a>
// //                 </div>
// //               </>
// //             )}
// //           </form>
// //         </Modal.Body>
// //       </Modal>
// //     </>
// //   )
// // }






























// import { useEffect, useState, useRef } from 'react'
// import { Outlet, Link, useNavigate } from 'react-router-dom'
// import { toAbsoluteUrl } from '../../../_metronic/helpers'
// import { Modal } from 'react-bootstrap'
// import * as Yup from 'yup'
// import { useFormik } from 'formik'
// import clsx from 'clsx'
// import { successToast, errorToast } from '../../../_metronic/helpers/components/Toaster'
// import axios from 'axios'

// // Phone validation schema
// const PhoneVerificationSchema = Yup.object().shape({
//   phoneNumber: Yup.string()
//     .required('Phone number is required')
//     .matches(/^[6-9]\d{9}$/, 'Enter a valid Indian mobile number starting with 6, 7, 8, or 9'),
//   otp1: Yup.string()
//     .required('OTP is required')
//     .matches(/^[0-9]$/, 'Must be a digit'),
//   otp2: Yup.string()
//     .required('OTP is required')
//     .matches(/^[0-9]$/, 'Must be a digit'),
//   otp3: Yup.string()
//     .required('OTP is required')
//     .matches(/^[0-9]$/, 'Must be a digit'),
//   otp4: Yup.string()
//     .required('OTP is required')
//     .matches(/^[0-9]$/, 'Must be a digit'),
// })

// export const AuthLayout = () => {
//   const navigate = useNavigate()
//   const [showModal, setShowModal] = useState(false)
//   const [otpSent, setOtpSent] = useState(false)
//   const [phoneNumber, setPhoneNumber] = useState('')
//   const [isResending, setIsResending] = useState(false)
//   const [isSubmitting, setIsSubmitting] = useState(false)
//   const [countryCode, setCountryCode] = useState('91') // Default to India

//   // References for OTP input fields
//   const inputRef1 = useRef<HTMLInputElement>(null)
//   const inputRef2 = useRef<HTMLInputElement>(null)
//   const inputRef3 = useRef<HTMLInputElement>(null)
//   const inputRef4 = useRef<HTMLInputElement>(null)

//   useEffect(() => {
//     const root = document.getElementById('root')
//     if (root) {
//       root.style.height = '100%'
//     }
//     return () => {
//       if (root) {
//         root.style.height = 'auto'
//       }
//     }
//   }, [])

//   const handleRegisterClick = (e: React.MouseEvent) => {
//     e.preventDefault()
//     setShowModal(true)
//   }

//   const resetModal = () => {
//     setShowModal(false)
//     setOtpSent(false)
//     setPhoneNumber('')
//     formik.resetForm()
//   }


//   // const sendOTP = async (phoneNumber: string) => {
//   //   if (!phoneNumber) {
//   //     errorToast('Please enter a phone number')
//   //     return
//   //   }
//   //   // Additional validation for Indian mobile numbers
//   //   if (!/^[6-9]\d{9}$/.test(phoneNumber)) {
//   //     errorToast('Please enter a valid Indian mobile number starting with 6, 7, 8, or 9')
//   //     return
//   //   }
//   //   setIsSubmitting(true)
//   //   try {
//   //     console.log(`Sending OTP to: ${phoneNumber}`)
//   //     // Call the API to send OTP
//   //     const url = `https://pfc-backend-api.asmglobal.co.in/v1/api/sendOtp?mobile=${phoneNumber}&countryCode=${countryCode}&from=registration`
//   //     console.log(`API URL: ${url}`)
//   //     const response = await axios.get(url, {
//   //       headers: {
//   //         'accept': 'application/json',
//   //         'app-id': '3',
//   //         'client-id': '101212',
//   //       }
//   //     })
//   //     console.log('OTP API Response:', response)
//   //     console.log('OTP API Response Data:', response.data)
//   //     console.log('OTP API Response Status:', response.status)

//   //     // Check if response contains errors (even with 200 status)
//   //     if (response.data?.errors && response.data.errors.length > 0) {
//   //       const errorMessage = response.data.errors[0].message || 'Failed to send OTP. Please try again.'
//   //       errorToast(errorMessage)
//   //       return
//   //     }

//   //     // If we got a 200 response and no errors, consider it a success
//   //     if (response.status === 200) {
//   //       setPhoneNumber(phoneNumber)
//   //       setOtpSent(true)
//   //       successToast('OTP sent successfully')
//   //       localStorage.setItem('verifiedPhoneNumber', phoneNumber)
//   //       setTimeout(() => {
//   //         if (inputRef1.current) {
//   //           inputRef1.current.focus()
//   //         }
//   //       }, 100)
//   //     } else {
//   //       // This would only happen if we got a non-200 status
//   //       errorToast('Failed to send OTP. Please try again.')
//   //     }
//   //   } catch (error: any) {
//   //     console.error('OTP Send Error:', error)

//   //     // Extract error message from API response
//   //     let errorMessage = 'Failed to send OTP. Please try again.'

//   //     if (error.response?.data?.errors && error.response.data.errors.length > 0) {
//   //       errorMessage = error.response.data.errors[0].message
//   //     } else if (error.response?.data?.message) {
//   //       errorMessage = error.response.data.message
//   //     } else if (error.message) {
//   //       errorMessage = error.message
//   //     }

//   //     errorToast(errorMessage)
//   //   } finally {
//   //     setIsSubmitting(false)
//   //     setIsResending(false)
//   //   }
//   // }

//   const sendOTP = async (phoneNumber: string) => {
//     if (!phoneNumber) {
//       errorToast('Please enter a phone number')
//       return
//     }

//     console.log(`Bypassing OTP for development: ${phoneNumber}`)
//     successToast('Phone number verified successfully')
//     resetModal()
//     navigate('/auth/register')
//   }

//   const resendOTP = async () => {
//     setIsResending(true)
//     await sendOTP(phoneNumber)
//   }

//   const verifyOTP = async () => {
//     const otp = `${formik.values.otp1}${formik.values.otp2}${formik.values.otp3}${formik.values.otp4}`

//     if (otp.length !== 4) {
//       errorToast('Please enter the complete 4-digit OTP')
//       return
//     }

//     setIsSubmitting(true)
//     try {
//       console.log('Verifying OTP:', otp)
//       console.log('Phone number:', phoneNumber)

//       // Call the API to verify OTP
//       const response = await axios.post(
//         'https://pfc-backend-api.asmglobal.co.in/v1/api/validateOtp',
//         {
//           mobile: phoneNumber,
//           otp: otp
//         },
//         {
//           headers: {
//             'accept': 'application/json',
//             'Accept-Encoding': 'gzip',
//             'app-id': '3',
//             'client-id': '101212',
//             'Content-Type': 'application/json',
//           }
//         }
//       )

//       console.log('OTP verification response:', response)
//       console.log('OTP verification response data:', response.data)
//       console.log('OTP verification response status:', response.status)

//       // If we got a 200 response, consider it a success regardless of the response structure
//       if (response.status === 200) {
//         successToast('OTP verified successfully')
//         resetModal()
//         navigate('/auth/register')
//       } else {
//         errorToast('Invalid OTP. Please try again.')
//       }
//     } catch (error) {
//       console.error('OTP Verification Error:', error)
//       errorToast('Failed to verify OTP. Please try again.')
//     } finally {
//       setIsSubmitting(false)
//     }
//   }

//   const handleOtpInput = (e: React.ChangeEvent<HTMLInputElement>, nextRef: React.RefObject<HTMLInputElement> | null) => {
//     const value = e.target.value
//     // Only allow numbers
//     if (!/^\d*$/.test(value)) {
//       e.preventDefault()
//       return
//     }

//     if (value.length === 1 && nextRef && nextRef.current) {
//       nextRef.current.focus()
//     }
//   }

//   const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>, prevRef: React.RefObject<HTMLInputElement> | null) => {
//     // Handle backspace
//     if (e.key === 'Backspace' && prevRef && (e.target as HTMLInputElement).value === '') {
//       prevRef.current?.focus()
//     }
//   }

//   const formik = useFormik({
//     initialValues: {
//       phoneNumber: '',
//       otp1: '',
//       otp2: '',
//       otp3: '',
//       otp4: '',
//     },
//     validationSchema: PhoneVerificationSchema,
//     onSubmit: async (values) => {
//       console.log('Form submitted with values:', values)
//       if (!otpSent) {
//         console.log('Sending OTP to:', values.phoneNumber)
//         await sendOTP(values.phoneNumber)
//       } else {
//         console.log('Verifying OTP')
//         await verifyOTP()
//       }
//     },
//   })

//   return (
//     <>
//       <div className='d-flex flex-column flex-lg-row flex-column-fluid h-100'>
//         {/* begin::Body */}
//         <div
//           className='d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1'
//           style={{ background: '#003B73' }}
//         >
//           {/* begin::Form */}
//           <div className='d-flex'>
//             <img
//               alt='Logo'
//               src={toAbsoluteUrl('/media/logos/PFC Logo - white.png')}
//               style={{
//                 height: '50px !important',
//                 width: '100px',
//                 marginLeft: '-25px',
//                 marginTop: '-2px',
//               }}
//             />
//           </div>
//           <div className='d-flex flex-center flex-column flex-lg-row-fluid'>
//             <div className='w-lg-500px p-10'>
//               <Outlet />
//             </div>
//           </div>
//           {/* begin::Footer */}
//           <div className='d-flex flex-center flex-wrap px-5'>
//             <div className='d-flex fw-semibold text-white fs-base'>
//               <a href='#' className='px-5 text-white' target='_blank'>
//                 Copyright &copy; {new Date().getFullYear().toString()} Plastics For Change
//               </a>
//               <a href='https://www.plasticsforchange.org/' className='px-5 text-white' target='_blank'>
//                 Terms
//               </a>
//               <a
//                 href="https://www.plasticsforchange.org/contact-us"
//                 className="px-5 text-white"
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 Contact Us
//               </a>

//               <a href='#' className='px-5 text-white' onClick={handleRegisterClick}>
//                 Register
//               </a>
//             </div>
//           </div>
//         </div>
//         {/* begin::Aside */}
//         <div className='d-flex flex-lg-row-fluid w-lg-50 bgi-size-cover order-1 order-lg-2 overflow-hidden position-relative'>
//           <div style={{ left: '50%' }}>
//             {/* <video autoPlay muted loop style={{ maxWidth: '100%', position: 'fixed' }}>
//               <source src='/media/logos/intro_video.mp4' type='video/mp4' />
//               Your browser does not support HTML5 video.
//             </video> */}
//             <video
//               autoPlay
//               muted
//               loop
//               style={{
//                 width: '50%',
//                 height: '100vh',
//                 position: 'fixed',
//                 objectFit: 'cover',
//                 right: 0,
//                 top: 0,
//                 bottom: 0
//               }}
//             >
//               <source src='/media/logos/intro_video.mp4' type='video/mp4' />
//               Your browser does not support HTML5 video.
//             </video>
//           </div>
//         </div>
//       </div>
//       {/* Phone Verification Modal */}
//       <Modal show={showModal} onHide={resetModal} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>Verification</Modal.Title>
//         </Modal.Header>
//         <Modal.Body className="p-6">
//           <form onSubmit={formik.handleSubmit} noValidate className='form'>
//             <div className="text-center mb-5">
//               <h3 className="fw-bold mb-3">Welcome to Plastics for Change</h3>
//               <p className="text-muted fs-6">Let us verify your details</p>
//             </div>
//             {!otpSent ? (
//               <div className='mb-8'>
//                 <label className='form-label fs-6 fw-bold mb-3'>Enter your mobile number</label>
//                 <div className='d-flex'>
//                   <div className='input-group me-3'>
//                     <span className='input-group-text'>+{countryCode}</span>
//                     <input
//                       placeholder='Enter your 10-digit mobile number'
//                       {...formik.getFieldProps('phoneNumber')}
//                       className={clsx(
//                         'form-control form-control-lg',
//                         { 'is-invalid': formik.touched.phoneNumber && formik.errors.phoneNumber },
//                         { 'is-valid': formik.touched.phoneNumber && !formik.errors.phoneNumber }
//                       )}
//                       type='tel'
//                       name='phoneNumber'
//                       autoComplete='tel'
//                       maxLength={10}
//                       onInput={(e) => {
//                         // Only allow numeric input
//                         const target = e.target as HTMLInputElement;
//                         target.value = target.value.replace(/[^0-9]/g, '');
//                       }}
//                     />
//                   </div>
//                   <button
//                     type='button'
//                     className='btn btn-primary'
//                     disabled={isSubmitting ||
//                       !formik.values.phoneNumber ||
//                       formik.errors.phoneNumber !== undefined}
//                     onClick={(e) => {
//                       e.preventDefault(); // Prevent default form submission
//                       console.log('Send OTP button clicked');
//                       console.log('Phone number:', formik.values.phoneNumber);
//                       // Validate the phone number format before sending
//                       if (!/^[6-9]\d{9}$/.test(formik.values.phoneNumber)) {
//                         errorToast('Please enter a valid Indian mobile number starting with 6, 7, 8, or 9');
//                         return;
//                       }
//                       sendOTP(formik.values.phoneNumber);
//                     }}
//                   >
//                     Send OTP
//                     {isSubmitting && (
//                       <span className='ms-2 spinner-border spinner-border-sm' role='status' aria-hidden='true'></span>
//                     )}
//                   </button>
//                 </div>
//                 {formik.touched.phoneNumber && formik.errors.phoneNumber && (
//                   <div className='fv-plugins-message-container mt-2'>
//                     <div className='fv-help-block'>
//                       <span role='alert'>{formik.errors.phoneNumber}</span>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             ) : (
//               <>
//                 <div className='mb-8'>
//                   <label className='form-label fs-6 fw-bold mb-3'>
//                     Enter the OTP sent to +{countryCode} {phoneNumber.substring(0, 3)}*****{phoneNumber.substring(phoneNumber.length - 2)}
//                   </label>
//                   <div className='d-flex justify-content-center gap-3 mb-7'>
//                     <input
//                       ref={inputRef1}
//                       maxLength={1}
//                       className='form-control form-control-lg text-center fw-bold fs-2'
//                       style={{ width: '60px', height: '60px' }}
//                       {...formik.getFieldProps('otp1')}
//                       onChange={(e) => {
//                         formik.handleChange(e);
//                         handleOtpInput(e, inputRef2);
//                       }}
//                       onKeyDown={(e) => handleKeyDown(e, null)}
//                     />
//                     <input
//                       ref={inputRef2}
//                       maxLength={1}
//                       className='form-control form-control-lg text-center fw-bold fs-2'
//                       style={{ width: '60px', height: '60px' }}
//                       {...formik.getFieldProps('otp2')}
//                       onChange={(e) => {
//                         formik.handleChange(e);
//                         handleOtpInput(e, inputRef3);
//                       }}
//                       onKeyDown={(e) => handleKeyDown(e, inputRef1)}
//                     />
//                     <input
//                       ref={inputRef3}
//                       maxLength={1}
//                       className='form-control form-control-lg text-center fw-bold fs-2'
//                       style={{ width: '60px', height: '60px' }}
//                       {...formik.getFieldProps('otp3')}
//                       onChange={(e) => {
//                         formik.handleChange(e);
//                         handleOtpInput(e, inputRef4);
//                       }}
//                       onKeyDown={(e) => handleKeyDown(e, inputRef2)}
//                     />
//                     <input
//                       ref={inputRef4}
//                       maxLength={1}
//                       className='form-control form-control-lg text-center fw-bold fs-2'
//                       style={{ width: '60px', height: '60px' }}
//                       {...formik.getFieldProps('otp4')}
//                       onChange={(e) => {
//                         formik.handleChange(e);
//                       }}
//                       onKeyDown={(e) => handleKeyDown(e, inputRef3)}
//                     />
//                   </div>
//                   <div className='text-center mb-10'>
//                     <span className='text-muted me-2'>Didn't receive OTP Code?</span>
//                     <a
//                       href='#'
//                       className='link-primary fw-bold'
//                       onClick={(e) => {
//                         e.preventDefault();
//                         if (!isResending) {
//                           resendOTP();
//                         }
//                       }}
//                     >
//                       {isResending ? 'Sending...' : 'Resend Code'}
//                     </a>
//                   </div>
//                 </div>
//                 <div className='d-flex justify-content-between'>
//                   <a href='#' className='btn btn-link' onClick={resetModal}>
//                     Cancel
//                   </a>
//                   <button
//                     type='button'
//                     className='btn btn-primary'
//                     disabled={isSubmitting}
//                     onClick={(e) => {
//                       e.preventDefault();
//                       console.log('Verify OTP button clicked');
//                       verifyOTP();
//                     }}
//                   >
//                     Confirm
//                     {isSubmitting && (
//                       <span className='ms-2 spinner-border spinner-border-sm' role='status' aria-hidden='true'></span>
//                     )}
//                   </button>
//                 </div>
//                 <div className='d-flex justify-content-between mt-5 pt-3 border-top'>
//                   <a href='https://www.plasticsforchange.org/privacy-policy' className='link-primary'>Privacy Policy</a>
//                   <a href='https://www.plasticsforchange.org/' className='link-primary'>Terms & Conditions</a>
//                 </div>
//               </>
//             )}
//           </form>
//         </Modal.Body>
//       </Modal>
//     </>
//   )
// }





// /* eslint-disable jsx-a11y/anchor-is-valid */
// import { useEffect } from 'react'
// import { Outlet, Link } from 'react-router-dom'
// import { toAbsoluteUrl } from '../../../_metronic/helpers'

// const AuthLayout = () => {
//   useEffect(() => {
//     const root = document.getElementById('root')
//     if (root) {
//       root.style.height = '100%'
//     }
//     return () => {
//       if (root) {
//         root.style.height = 'auto'
//       }
//     }
//   }, [])

//   return (
//     <div className='d-flex flex-column flex-lg-row flex-column-fluid h-100'>
//       {/* begin::Body */}
//       <div
//         className='d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1'
//         style={{ background: '#003B73' }}
//       >
//         {/* begin::Form */}
//         <div className='d-flex  '>
//           <img
//             alt='Logo'
//             src={toAbsoluteUrl('/media/logos/PFC Logo - white.png')}
//             style={{
//               height: '50px !important',
//               width: '100px',
//               // width: '50px',
//               marginLeft: '-25px',
//               marginTop: '-2px',
//             }}
//           // className='h-100px'
//           />
//         </div>

//         <div className='d-flex flex-center flex-column flex-lg-row-fluid'>
//           {/* <div style={{ fontSize: '42px', marginBottom: '42px', color: 'white' }}>
//             Gembira Dapat Berjumpa Awak
//           </div>{' '} */}
//           {/* begin::Wrapper */}
//           <div className='w-lg-500px p-10'>
//             <Outlet />
//           </div>
//           {/* end::Wrapper */}
//         </div>
//         {/* end::Form */}

//         {/* begin::Footer */}
//         <div className='d-flex flex-center flex-wrap px-5'>
//           {/* begin::Links */}
//           <div className='d-flex fw-semibold text-white fs-base'>
//             <a href='#' className='px-5 text-white' target='_blank'>
//               Copyright &copy; {new Date().getFullYear().toString()} ASM Global
//             </a>
//             <a href='#' className='px-5 text-white' target='_blank'>
//               Terms
//             </a>

//             {/* <a href='#' className='px-5' target='_blank'>
//               Plans
//             </a> */}

//             <a href='#' className='px-5 text-white' target='_blank'>
//               Contact Us
//             </a>

//             <Link to='/auth/register' className='px-5 text-white'>
//               Register
//             </Link>


//           </div>
//           {/* end::Links */}
//         </div>
//         {/* end::Footer */}
//       </div>
//       {/* end::Body */}

//       {/* begin::Aside */}
//       <div className='d-flex flex-lg-row-fluid w-lg-50 bgi-size-cover order-1 order-lg-2 overflow-hidden position-relative'>
//         <div
//           // className='position-fixed'
//           style={{ left: '50%' }}
//         >
//           <video autoPlay muted loop style={{ maxWidth: '100%', position: 'fixed' }}>
//             <source src='/media/logos/intro_video.mp4' type='video/mp4' />
//             Your browser does not support HTML5 video.
//           </video>
//         </div>
//       </div>
//       {/* end::Aside */}
//     </div>
//   )
// }

// export { AuthLayout }




























// import { useEffect, useState, useRef } from 'react'
// import { Outlet, Link, useNavigate } from 'react-router-dom'
// import { toAbsoluteUrl } from '../../../_metronic/helpers'
// import { Modal } from 'react-bootstrap'
// import * as Yup from 'yup'
// import { useFormik } from 'formik'
// import clsx from 'clsx'
// import { successToast, errorToast } from '../../../_metronic/helpers/components/Toaster'

// // Removed strict validation for development
// const PhoneVerificationSchema = Yup.object().shape({
//   phoneNumber: Yup.string(),
//   otp1: Yup.string(),
//   otp2: Yup.string(),
//   otp3: Yup.string(),
//   otp4: Yup.string(),
// })

// export const AuthLayout = () => {
//   const navigate = useNavigate()
//   const [showModal, setShowModal] = useState(false)
//   const [otpSent, setOtpSent] = useState(false)
//   const [phoneNumber, setPhoneNumber] = useState('')
//   const [isResending, setIsResending] = useState(false)

//   // References for OTP input fields
//   const inputRef1 = useRef<HTMLInputElement>(null)
//   const inputRef2 = useRef<HTMLInputElement>(null)
//   const inputRef3 = useRef<HTMLInputElement>(null)
//   const inputRef4 = useRef<HTMLInputElement>(null)

//   useEffect(() => {
//     const root = document.getElementById('root')
//     if (root) {
//       root.style.height = '100%'
//     }
//     return () => {
//       if (root) {
//         root.style.height = 'auto'
//       }
//     }
//   }, [])

//   const handleRegisterClick = (e: React.MouseEvent) => {
//     e.preventDefault()
//     setShowModal(true)
//   }

//   const resetModal = () => {
//     setShowModal(false)
//     setOtpSent(false)
//     setPhoneNumber('')
//     formik.resetForm()
//   }

//   const sendOTP = async (phoneNumber: string) => {
//     try {
//       // For development, immediately proceed to OTP screen without validation
//       console.log('Sending OTP to:', phoneNumber)
//       // No delay for testing
//       setPhoneNumber(phoneNumber || '8888888888') // Default number if empty
//       setOtpSent(true)
//       // Focus the first OTP input field
//       setTimeout(() => {
//         if (inputRef1.current) {
//           inputRef1.current.focus()
//         }
//       }, 100)
//     } catch (error) {
//       console.error('OTP Send Error:', error)
//     } finally {
//       setIsResending(false)
//     }
//   }

//   const resendOTP = async () => {
//     setIsResending(true)
//     await sendOTP(phoneNumber)
//   }

//   const verifyOTP = async () => {
//     try {
//       const otp = `${formik.values.otp1}${formik.values.otp2}${formik.values.otp3}${formik.values.otp4}`
//       // For development, always succeed without validation
//       console.log('Verifying OTP:', otp)
//       // No delay for testing
//       resetModal()
//       navigate('/auth/register')
//     } catch (error) {
//       console.error('OTP Verification Error:', error)
//     }
//   }

//   const handleOtpInput = (e: React.ChangeEvent<HTMLInputElement>, nextRef: React.RefObject<HTMLInputElement> | null) => {
//     const value = e.target.value
//     if (value.length === 1 && nextRef && nextRef.current) {
//       nextRef.current.focus()
//     }
//   }

//   const formik = useFormik({
//     initialValues: {
//       phoneNumber: '',
//       otp1: '',
//       otp2: '',
//       otp3: '',
//       otp4: '',
//     },
//     validationSchema: PhoneVerificationSchema,
//     onSubmit: async (values) => {
//       if (!otpSent) {
//         await sendOTP(values.phoneNumber)
//       } else {
//         await verifyOTP()
//       }
//     },
//   })

//   return (
//     <>
//       <div className='d-flex flex-column flex-lg-row flex-column-fluid h-100'>
//         {/* begin::Body */}
//         <div
//           className='d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1'
//           style={{ background: '#003B73' }}
//         >
//           {/* begin::Form */}
//           <div className='d-flex'>
//             <img
//               alt='Logo'
//               src={toAbsoluteUrl('/media/logos/PFC Logo - white.png')}
//               style={{
//                 height: '50px !important',
//                 width: '100px',
//                 marginLeft: '-25px',
//                 marginTop: '-2px',
//               }}
//             />
//           </div>

//           <div className='d-flex flex-center flex-column flex-lg-row-fluid'>
//             <div className='w-lg-500px p-10'>
//               <Outlet />
//             </div>
//           </div>

//           {/* begin::Footer */}
//           <div className='d-flex flex-center flex-wrap px-5'>
//             <div className='d-flex fw-semibold text-white fs-base'>
//               <a href='#' className='px-5 text-white' target='_blank'>
//                 Copyright &copy; {new Date().getFullYear().toString()} Plastics For Change
//               </a>
//               <a href='#' className='px-5 text-white' target='_blank'>
//                 Terms
//               </a>
//               <a href='#' className='px-5 text-white' target='_blank'>
//                 Contact Us
//               </a>
//               <a href='#' className='px-5 text-white' onClick={handleRegisterClick}>
//                 Register
//               </a>
//             </div>
//           </div>
//         </div>

//         {/* begin::Aside */}
//         <div className='d-flex flex-lg-row-fluid w-lg-50 bgi-size-cover order-1 order-lg-2 overflow-hidden position-relative'>
//           <div style={{ left: '50%' }}>
//             {/* <video autoPlay muted loop style={{ maxWidth: '100%', position: 'fixed' }}>
//               <source src='/media/logos/intro_video.mp4' type='video/mp4' />
//               Your browser does not support HTML5 video.
//             </video> */}
//             <video
//               autoPlay
//               muted
//               loop
//               style={{
//                 width: '50%',
//                 height: '100vh',
//                 position: 'fixed',
//                 objectFit: 'cover',
//                 right: 0,
//                 top: 0,
//                 bottom: 0
//               }}
//             >
//               <source src='/media/logos/intro_video.mp4' type='video/mp4' />
//               Your browser does not support HTML5 video.
//             </video>
//           </div>
//         </div>
//       </div>

//       {/* Phone Verification Modal */}
//       <Modal show={showModal} onHide={resetModal} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>Verification</Modal.Title>
//         </Modal.Header>
//         <Modal.Body className="p-6">
//           <form onSubmit={formik.handleSubmit} noValidate className='form'>
//             <div className="text-center mb-5">
//               <h3 className="fw-bold mb-3">Welcome to Plastics for Change</h3>
//               <p className="text-muted fs-6">Let us verify your details</p>
//             </div>

//             {!otpSent ? (
//               <div className='mb-8'>
//                 <label className='form-label fs-6 fw-bold mb-3'>Enter your mobile number</label>
//                 <div className='d-flex'>
//                   <input
//                     placeholder='Enter your 10-digit mobile number'
//                     {...formik.getFieldProps('phoneNumber')}
//                     className={clsx(
//                       'form-control form-control-lg me-3',
//                       { 'is-invalid': formik.touched.phoneNumber && formik.errors.phoneNumber },
//                       { 'is-valid': formik.touched.phoneNumber && !formik.errors.phoneNumber }
//                     )}
//                     type='text'
//                     name='phoneNumber'
//                     autoComplete='off'
//                   />
//                   <button
//                     type='submit'
//                     className='btn btn-primary'
//                   >
//                     Send OTP
//                     {formik.isSubmitting && (
//                       <span className='ms-2 spinner-border spinner-border-sm' role='status' aria-hidden='true'></span>
//                     )}
//                   </button>
//                 </div>
//                 {formik.touched.phoneNumber && formik.errors.phoneNumber && (
//                   <div className='fv-plugins-message-container mt-2'>
//                     <div className='fv-help-block'>
//                       <span role='alert'>{formik.errors.phoneNumber}</span>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             ) : (
//               <>
//                 <div className='mb-8'>
//                   <label className='form-label fs-6 fw-bold mb-3'>
//                     Enter the OTP sent to +{phoneNumber.substring(0, 3)}*****{phoneNumber.substring(phoneNumber.length - 3)}
//                   </label>
//                   <div className='d-flex justify-content-center gap-3 mb-7'>
//                     <input
//                       ref={inputRef1}
//                       maxLength={1}
//                       className='form-control form-control-lg text-center fw-bold fs-2'
//                       style={{ width: '60px', height: '60px' }}
//                       {...formik.getFieldProps('otp1')}
//                       onChange={(e) => {
//                         formik.handleChange(e);
//                         handleOtpInput(e, inputRef2);
//                       }}
//                     />
//                     <input
//                       ref={inputRef2}
//                       maxLength={1}
//                       className='form-control form-control-lg text-center fw-bold fs-2'
//                       style={{ width: '60px', height: '60px' }}
//                       {...formik.getFieldProps('otp2')}
//                       onChange={(e) => {
//                         formik.handleChange(e);
//                         handleOtpInput(e, inputRef3);
//                       }}
//                     />
//                     <input
//                       ref={inputRef3}
//                       maxLength={1}
//                       className='form-control form-control-lg text-center fw-bold fs-2'
//                       style={{ width: '60px', height: '60px' }}
//                       {...formik.getFieldProps('otp3')}
//                       onChange={(e) => {
//                         formik.handleChange(e);
//                         handleOtpInput(e, inputRef4);
//                       }}
//                     />
//                     <input
//                       ref={inputRef4}
//                       maxLength={1}
//                       className='form-control form-control-lg text-center fw-bold fs-2'
//                       style={{ width: '60px', height: '60px' }}
//                       {...formik.getFieldProps('otp4')}
//                       onChange={(e) => {
//                         formik.handleChange(e);
//                       }}
//                     />
//                   </div>

//                   <div className='text-center mb-10'>
//                     <span className='text-muted me-2'>Didn't receive OTP Code?</span>
//                     <a
//                       href='#'
//                       className='link-primary fw-bold'
//                       onClick={(e) => {
//                         e.preventDefault();
//                         if (!isResending) {
//                           resendOTP();
//                         }
//                       }}
//                     >
//                       {isResending ? 'Sending...' : 'Resend Code'}
//                     </a>
//                   </div>
//                 </div>

//                 <div className='d-flex justify-content-between'>
//                   <a href='#' className='btn btn-link' onClick={resetModal}>
//                     Cancel
//                   </a>
//                   <button
//                     type='submit'
//                     className='btn btn-primary'
//                   >
//                     Confirm
//                     {formik.isSubmitting && (
//                       <span className='ms-2 spinner-border spinner-border-sm' role='status' aria-hidden='true'></span>
//                     )}
//                   </button>
//                 </div>

//                 <div className='d-flex justify-content-between mt-5 pt-3 border-top'>
//                   <a href='#' className='link-primary'>Privacy Policy</a>
//                   <a href='#' className='link-primary'>Terms & Conditions</a>
//                 </div>
//               </>
//             )}
//           </form>
//         </Modal.Body>
//       </Modal>
//     </>
//   )
// }






























import { useEffect, useState, useRef } from 'react'
import { Outlet, Link, useNavigate } from 'react-router-dom'
import { toAbsoluteUrl } from '../../../_metronic/helpers'
import { Modal } from 'react-bootstrap'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import clsx from 'clsx'
import { successToast, errorToast } from '../../../_metronic/helpers/components/Toaster'
import axios from 'axios'

// Phone validation schema
const PhoneVerificationSchema = Yup.object().shape({
  phoneNumber: Yup.string()
    .required('Phone number is required')
    .matches(/^[6-9]\d{9}$/, 'Enter a valid Indian mobile number starting with 6, 7, 8, or 9'),
  otp1: Yup.string()
    .required('OTP is required')
    .matches(/^[0-9]$/, 'Must be a digit'),
  otp2: Yup.string()
    .required('OTP is required')
    .matches(/^[0-9]$/, 'Must be a digit'),
  otp3: Yup.string()
    .required('OTP is required')
    .matches(/^[0-9]$/, 'Must be a digit'),
  otp4: Yup.string()
    .required('OTP is required')
    .matches(/^[0-9]$/, 'Must be a digit'),
})

export const AuthLayout = () => {
  const navigate = useNavigate()
  const [showModal, setShowModal] = useState(false)
  const [otpSent, setOtpSent] = useState(false)
  const [phoneNumber, setPhoneNumber] = useState('')
  const [isResending, setIsResending] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [countryCode, setCountryCode] = useState('91') // Default to India

  // References for OTP input fields
  const inputRef1 = useRef<HTMLInputElement>(null)
  const inputRef2 = useRef<HTMLInputElement>(null)
  const inputRef3 = useRef<HTMLInputElement>(null)
  const inputRef4 = useRef<HTMLInputElement>(null)

  useEffect(() => {
    const root = document.getElementById('root')
    if (root) {
      root.style.height = '100%'
    }
    return () => {
      if (root) {
        root.style.height = 'auto'
      }
    }
  }, [])

  const handleRegisterClick = (e: React.MouseEvent) => {
    e.preventDefault()
    setShowModal(true)
  }

  const resetModal = () => {
    setShowModal(false)
    setOtpSent(false)
    setPhoneNumber('')
    formik.resetForm()
  }


  const sendOTP = async (phoneNumber: string) => {
    if (!phoneNumber) {
      errorToast('Please enter a phone number')
      return
    }
    // Additional validation for Indian mobile numbers
    if (!/^[6-9]\d{9}$/.test(phoneNumber)) {
      errorToast('Please enter a valid Indian mobile number starting with 6, 7, 8, or 9')
      return
    }
    setIsSubmitting(true)
    try {
      console.log(`Sending OTP to: ${phoneNumber}`)
      // Call the API to send OTP
      const url = `https://pfc-backend-api.asmglobal.co.in/v1/api/sendOtp?mobile=${phoneNumber}&countryCode=${countryCode}&from=registration`
      console.log(`API URL: ${url}`)
      const response = await axios.get(url, {
        headers: {
          'accept': 'application/json',
          'app-id': '3',
          'client-id': '101212',
        }
      })
      console.log('OTP API Response:', response)
      console.log('OTP API Response Data:', response.data)
      console.log('OTP API Response Status:', response.status)

      // Check if response contains errors (even with 200 status)
      if (response.data?.errors && response.data.errors.length > 0) {
        const errorMessage = response.data.errors[0].message || 'Failed to send OTP. Please try again.'
        errorToast(errorMessage)
        return
      }

      // If we got a 200 response and no errors, consider it a success
      if (response.status === 200) {
        setPhoneNumber(phoneNumber)
        setOtpSent(true)
        successToast('OTP sent successfully')
        localStorage.setItem('verifiedPhoneNumber', phoneNumber)
        setTimeout(() => {
          if (inputRef1.current) {
            inputRef1.current.focus()
          }
        }, 100)
      } else {
        // This would only happen if we got a non-200 status
        errorToast('Failed to send OTP. Please try again.')
      }
    } catch (error: any) {
      console.error('OTP Send Error:', error)

      // Extract error message from API response
      let errorMessage = 'Failed to send OTP. Please try again.'

      if (error.response?.data?.errors && error.response.data.errors.length > 0) {
        errorMessage = error.response.data.errors[0].message
      } else if (error.response?.data?.message) {
        errorMessage = error.response.data.message
      } else if (error.message) {
        errorMessage = error.message
      }

      errorToast(errorMessage)
    } finally {
      setIsSubmitting(false)
      setIsResending(false)
    }
  }

  // const sendOTP = async (phoneNumber: string) => {
  //   if (!phoneNumber) {
  //     errorToast('Please enter a phone number')
  //     return
  //   }

  //   console.log(`Bypassing OTP for development: ${phoneNumber}`)
  //   successToast('Phone number verified successfully')
  //   resetModal()
  //   navigate('/auth/register')
  // }

  const resendOTP = async () => {
    setIsResending(true)
    await sendOTP(phoneNumber)
  }

  const verifyOTP = async () => {
    const otp = `${formik.values.otp1}${formik.values.otp2}${formik.values.otp3}${formik.values.otp4}`

    if (otp.length !== 4) {
      errorToast('Please enter the complete 4-digit OTP')
      return
    }

    setIsSubmitting(true)
    try {
      console.log('Verifying OTP:', otp)
      console.log('Phone number:', phoneNumber)

      // Call the API to verify OTP
      const response = await axios.post(
        'https://pfc-backend-api.asmglobal.co.in/v1/api/validateOtp',
        {
          mobile: phoneNumber,
          otp: otp
        },
        {
          headers: {
            'accept': 'application/json',
            'Accept-Encoding': 'gzip',
            'app-id': '3',
            'client-id': '101212',
            'Content-Type': 'application/json',
          }
        }
      )

      console.log('OTP verification response:', response)
      console.log('OTP verification response data:', response.data)
      console.log('OTP verification response status:', response.status)

      // If we got a 200 response, consider it a success regardless of the response structure
      if (response.status === 200) {
        successToast('OTP verified successfully')
        resetModal()
        navigate('/auth/register')
      } else {
        errorToast('Invalid OTP. Please try again.')
      }
    } catch (error) {
      console.error('OTP Verification Error:', error)
      errorToast('Failed to verify OTP. Please try again.')
    } finally {
      setIsSubmitting(false)
    }
  }


  // const verifyOTP = async () => {
  //   const otp = `${formik.values.otp1}${formik.values.otp2}${formik.values.otp3}${formik.values.otp4}`
  //   if (otp.length !== 4) {
  //     errorToast('Please enter the complete 4-digit OTP')
  //     return
  //   }
  //   setIsSubmitting(true)

  //   try {
  //     // Store the phone number in localStorage for later use
  //     localStorage.setItem('verifiedPhoneNumber', JSON.stringify(phoneNumber));

  //     // Bypass OTP verification - directly proceed to success
  //     successToast('OTP verified successfully')
  //     resetModal()
  //     navigate('/auth/register')

  //   } catch (error) {
  //     console.error('Navigation Error:', error)
  //     errorToast('Something went wrong. Please try again.')
  //   } finally {
  //     setIsSubmitting(false)
  //   }
  // }

  const handleOtpInput = (e: React.ChangeEvent<HTMLInputElement>, nextRef: React.RefObject<HTMLInputElement> | null) => {
    const value = e.target.value
    // Only allow numbers
    if (!/^\d*$/.test(value)) {
      e.preventDefault()
      return
    }

    if (value.length === 1 && nextRef && nextRef.current) {
      nextRef.current.focus()
    }
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>, prevRef: React.RefObject<HTMLInputElement> | null) => {
    // Handle backspace
    if (e.key === 'Backspace' && prevRef && (e.target as HTMLInputElement).value === '') {
      prevRef.current?.focus()
    }
  }

  const formik = useFormik({
    initialValues: {
      phoneNumber: '',
      otp1: '',
      otp2: '',
      otp3: '',
      otp4: '',
    },
    validationSchema: PhoneVerificationSchema,
    onSubmit: async (values) => {
      console.log('Form submitted with values:', values)
      if (!otpSent) {
        console.log('Sending OTP to:', values.phoneNumber)
        await sendOTP(values.phoneNumber)
      } else {
        console.log('Verifying OTP')
        await verifyOTP()
      }
    },
  })

  return (
    <>
      <div className='d-flex flex-column flex-lg-row flex-column-fluid h-100'>
        {/* begin::Body */}
        <div
          className='d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1'
          style={{ background: '#003B73' }}
        >
          {/* begin::Form */}
          <div className='d-flex'>
            <img
              alt='Logo'
              src={toAbsoluteUrl('/media/logos/PFC Logo - white.png')}
              style={{
                height: '50px !important',
                width: '100px',
                marginLeft: '-25px',
                marginTop: '-2px',
              }}
            />
          </div>
          <div className='d-flex flex-center flex-column flex-lg-row-fluid'>
            <div className='w-lg-500px p-10'>
              <Outlet />
            </div>
          </div>
          {/* begin::Footer */}
          <div className='d-flex flex-center flex-wrap px-5'>
            <div className='d-flex fw-semibold text-white fs-base'>
              <a href='#' className='px-5 text-white' target='_blank'>
                Copyright &copy; {new Date().getFullYear().toString()} Plastics For Change
              </a>
              <a href='https://www.plasticsforchange.org/' className='px-5 text-white' target='_blank'>
                Terms
              </a>
              <a
                href="https://www.plasticsforchange.org/contact-us"
                className="px-5 text-white"
                target="_blank"
                rel="noopener noreferrer"
              >
                Contact Us
              </a>

              <a href='#' className='px-5 text-white' onClick={handleRegisterClick}>
                Register
              </a>
            </div>
          </div>
        </div>
        {/* begin::Aside */}
        <div className='d-flex flex-lg-row-fluid w-lg-50 bgi-size-cover order-1 order-lg-2 overflow-hidden position-relative'>
          <div style={{ left: '50%' }}>
            {/* <video autoPlay muted loop style={{ maxWidth: '100%', position: 'fixed' }}>
              <source src='/media/logos/intro_video.mp4' type='video/mp4' />
              Your browser does not support HTML5 video.
            </video> */}
            <video
              autoPlay
              muted
              loop
              style={{
                width: '50%',
                height: '100vh',
                position: 'fixed',
                objectFit: 'cover',
                right: 0,
                top: 0,
                bottom: 0
              }}
            >
              <source src='/media/logos/intro_video.mp4' type='video/mp4' />
              Your browser does not support HTML5 video.
            </video>
          </div>
        </div>
      </div>
      {/* Phone Verification Modal */}
      <Modal show={showModal} onHide={resetModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Verification</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-6">
          <form onSubmit={formik.handleSubmit} noValidate className='form'>
            <div className="text-center mb-5">
              <h3 className="fw-bold mb-3">Welcome to Plastics for Change</h3>
              <p className="text-muted fs-6">Let us verify your details</p>
            </div>
            {!otpSent ? (
              <div className='mb-8'>
                <label className='form-label fs-6 fw-bold mb-3'>Enter your mobile number</label>
                <div className='d-flex'>
                  <div className='input-group me-3'>
                    <span className='input-group-text'>+{countryCode}</span>
                    <input
                      placeholder='Enter your 10-digit mobile number'
                      {...formik.getFieldProps('phoneNumber')}
                      className={clsx(
                        'form-control form-control-lg',
                        { 'is-invalid': formik.touched.phoneNumber && formik.errors.phoneNumber },
                        { 'is-valid': formik.touched.phoneNumber && !formik.errors.phoneNumber }
                      )}
                      type='tel'
                      name='phoneNumber'
                      autoComplete='tel'
                      maxLength={10}
                      onInput={(e) => {
                        // Only allow numeric input
                        const target = e.target as HTMLInputElement;
                        target.value = target.value.replace(/[^0-9]/g, '');
                      }}
                    />
                  </div>
                  <button
                    type='button'
                    className='btn btn-primary'
                    disabled={isSubmitting ||
                      !formik.values.phoneNumber ||
                      formik.errors.phoneNumber !== undefined}
                    onClick={(e) => {
                      e.preventDefault(); // Prevent default form submission
                      console.log('Send OTP button clicked');
                      console.log('Phone number:', formik.values.phoneNumber);
                      // Validate the phone number format before sending
                      if (!/^[6-9]\d{9}$/.test(formik.values.phoneNumber)) {
                        errorToast('Please enter a valid Indian mobile number starting with 6, 7, 8, or 9');
                        return;
                      }
                      sendOTP(formik.values.phoneNumber);
                    }}
                  >
                    Send OTP
                    {isSubmitting && (
                      <span className='ms-2 spinner-border spinner-border-sm' role='status' aria-hidden='true'></span>
                    )}
                  </button>
                </div>
                {formik.touched.phoneNumber && formik.errors.phoneNumber && (
                  <div className='fv-plugins-message-container mt-2'>
                    <div className='fv-help-block'>
                      <span role='alert'>{formik.errors.phoneNumber}</span>
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <>
                <div className='mb-8'>
                  <label className='form-label fs-6 fw-bold mb-3'>
                    Enter the OTP sent to +{countryCode} {phoneNumber.substring(0, 3)}*****{phoneNumber.substring(phoneNumber.length - 2)}
                  </label>
                  <div className='d-flex justify-content-center gap-3 mb-7'>
                    <input
                      ref={inputRef1}
                      maxLength={1}
                      className='form-control form-control-lg text-center fw-bold fs-2'
                      style={{ width: '60px', height: '60px' }}
                      {...formik.getFieldProps('otp1')}
                      onChange={(e) => {
                        formik.handleChange(e);
                        handleOtpInput(e, inputRef2);
                      }}
                      onKeyDown={(e) => handleKeyDown(e, null)}
                    />
                    <input
                      ref={inputRef2}
                      maxLength={1}
                      className='form-control form-control-lg text-center fw-bold fs-2'
                      style={{ width: '60px', height: '60px' }}
                      {...formik.getFieldProps('otp2')}
                      onChange={(e) => {
                        formik.handleChange(e);
                        handleOtpInput(e, inputRef3);
                      }}
                      onKeyDown={(e) => handleKeyDown(e, inputRef1)}
                    />
                    <input
                      ref={inputRef3}
                      maxLength={1}
                      className='form-control form-control-lg text-center fw-bold fs-2'
                      style={{ width: '60px', height: '60px' }}
                      {...formik.getFieldProps('otp3')}
                      onChange={(e) => {
                        formik.handleChange(e);
                        handleOtpInput(e, inputRef4);
                      }}
                      onKeyDown={(e) => handleKeyDown(e, inputRef2)}
                    />
                    <input
                      ref={inputRef4}
                      maxLength={1}
                      className='form-control form-control-lg text-center fw-bold fs-2'
                      style={{ width: '60px', height: '60px' }}
                      {...formik.getFieldProps('otp4')}
                      onChange={(e) => {
                        formik.handleChange(e);
                      }}
                      onKeyDown={(e) => handleKeyDown(e, inputRef3)}
                    />
                  </div>
                  <div className='text-center mb-10'>
                    <span className='text-muted me-2'>Didn't receive OTP Code?</span>
                    <a
                      href='#'
                      className='link-primary fw-bold'
                      onClick={(e) => {
                        e.preventDefault();
                        if (!isResending) {
                          resendOTP();
                        }
                      }}
                    >
                      {isResending ? 'Sending...' : 'Resend Code'}
                    </a>
                  </div>
                </div>
                <div className='d-flex justify-content-between'>
                  <a href='#' className='btn btn-link' onClick={resetModal}>
                    Cancel
                  </a>
                  <button
                    type='button'
                    className='btn btn-primary'
                    disabled={isSubmitting}
                    onClick={(e) => {
                      e.preventDefault();
                      console.log('Verify OTP button clicked');
                      verifyOTP();
                    }}
                  >
                    Confirm
                    {isSubmitting && (
                      <span className='ms-2 spinner-border spinner-border-sm' role='status' aria-hidden='true'></span>
                    )}
                  </button>
                </div>
                <div className='d-flex justify-content-between mt-5 pt-3 border-top'>
                  <a href='https://www.plasticsforchange.org/privacy-policy' className='link-primary'>Privacy Policy</a>
                  <a href='https://www.plasticsforchange.org/' className='link-primary'>Terms & Conditions</a>
                </div>
              </>
            )}
          </form>
        </Modal.Body>
      </Modal>
    </>
  )
}